<template>
  <div class="container" style="margin-top: 1em; margin-bottom: 1em;">
    <pre class="version-content">{{ versionContent }}</pre>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'

const versionContent = ref('')

onMounted(async () => {
  try {
    const response = await fetch('/versions_history.txt')
    versionContent.value = await response.text()
  } catch (error) {
    console.error('Chyba při načítání souboru:', error)
    versionContent.value = 'Nepodařilo se načíst historii verzí.'
  }
})
</script>

<style scoped>
.version-content {
  font-family: 'Courier New', monospace;
  font-size: 14px;
  background-color: #f5f5f5;
  padding: 15px;
  border-radius: 4px;
  overflow-x: auto;
  white-space: pre-wrap;
  line-height: 1.5;
}
</style>

